import axios from 'src/utils/axios';

export interface SectionSummaryResponse {
  section_id: number;
  summary: string;
  empty: boolean;
  generated_at: string;
  model_version: string;
  profile_config_version: number;
  cached: boolean;
}

export interface SectionSummaryError {
  error: string;
  retryable: boolean;
  retryAfterSec?: number;
  status: number;
}

export async function fetchSectionSummary(args: {
  surveyId: number;
  sectionId: number;
  etag?: string;
}): Promise<{
  data: SectionSummaryResponse | null;
  etag?: string;
  status: number;
}> {
  const params: Record<string, string> = { survey_id: String(args.surveyId) };
  const headers: Record<string, string> = {};
  if (args.etag) {
    headers['If-None-Match'] = args.etag;
  }
  const resp = await axios.get<SectionSummaryResponse>(
    `data-vault/ai-summary/sections/${args.sectionId}/`,
    { params, headers, validateStatus: (s) => s === 200 || s === 304 }
  );
  return {
    data: resp.status === 200 ? resp.data : null,
    etag: resp.headers.etag,
    status: resp.status,
  };
}
